import React from 'react'

import { Formik } from 'formik'

import { Col, Row } from '_zari/core'

import * as FormGroups from './formGroups'

const ResumenMontosSection = ({ montos, flagVentaRapida }) => {
  return (
    <Formik initialValues={montos}>
      {({ values }) => (
        <Row>
          {flagVentaRapida ? (
            <>
              <Col xs={6} sm={3} md={6} />
              <Col xs={6} sm={3} md={6}>
                <FormGroups.ImporteTotalFormGroup iValue={values.sumaTotal} />
              </Col>
            </>
          ) : (
            <>
              <Col xs={6} sm={3} md={6}>
                <FormGroups.ImporteInafectoFormGroup iValue={values.sumaInafecto} />
              </Col>
              <Col xs={6} sm={3} md={6}>
                <FormGroups.ImporteExoneradoFormGroup iValue={values.sumaExonerado} />
              </Col>
              <Col xs={6} sm={3} md={6}>
                <FormGroups.ImporteGratuitoFormGroup iValue={values.sumaGratuito} />
              </Col>
              <Col xs={6} sm={3} md={6}>
                <FormGroups.ImporteGravadoFormGroup iValue={values.sumaGravado} />
              </Col>
              <Col xs={6} sm={3} md={6}>
                <FormGroups.ImporteIgvFormGroup iValue={values.sumaIgv} />
              </Col>
              <Col xs={6} sm={3} md={6}>
                <FormGroups.ImporteIcbperFormGroup iValue={values.sumaIcbper} />
              </Col>
              <Col xs={6} sm={3} md={6}>
                <FormGroups.ImporteDescuentoFormGroup iValue={values.sumaDescuento} />
              </Col>
              {values.sumaAnticipo !== 0 && (
                <>
                  <Col xs={6} sm={3} md={6}>
                    <FormGroups.ImporteAnticipoFormGroup iValue={values.sumaAnticipo} />
                  </Col>
                  <Col xs={6} sm={3} md={6} />
                </>
              )}
              <Col xs={6} sm={3} md={6}>
                <FormGroups.ImporteTotalFormGroup iValue={values.sumaTotal} />
              </Col>
            </>
          )}
        </Row>
      )}
    </Formik>
  )
}

export default React.memo(ResumenMontosSection)
